import React, { ReactNode, VFC } from 'react';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import { TEXT_COLOR } from '~/src/feature/Ambassador/constants';

interface Props {
  url: string;
  children: ReactNode;
}

const useStyles = makeStyles((theme) => ({
  link: {
    width: 'fit-content',
    marginBottom: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.typography.pxToRem(14),
    wordBreak: 'break-all',
    color: TEXT_COLOR,
    '&:hover': {
      color: TEXT_COLOR,
      opacity: 0.5,
    },
  },
}));

const SnsLink: VFC<Props> = ({ url, children }) => {
  const classes = useStyles();
  return (
    <Link
      href={url}
      target="_blank"
      rel="noopener"
      classes={{ root: classes.link }}
      underline="always"
    >
      {children}
    </Link>
  );
};

export default SnsLink;
